import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const SEVERITY_LABELS: Record<"hard_fail" | "warning", string> = {
  hard_fail: "Hard Fail",
  warning: "Warning",
};

type SeveritySelectProps = {
  value: "hard_fail" | "warning";
  onChange: (value: "hard_fail" | "warning") => void;
  disabled?: boolean;
  ariaLabel: string;
};

export function SeveritySelect({ value, onChange, disabled, ariaLabel }: SeveritySelectProps) {
  return (
    <Select
      value={value}
      onValueChange={(v) => onChange(v as "hard_fail" | "warning")}
      disabled={disabled}
    >
      <SelectTrigger className="h-8 w-[130px] rounded-lg bg-card text-xs" aria-label={ariaLabel}>
        <SelectValue>{SEVERITY_LABELS[value]}</SelectValue>
      </SelectTrigger>
      <SelectContent className="bg-popover border border-border">
        <SelectItem value="hard_fail">{SEVERITY_LABELS.hard_fail}</SelectItem>
        <SelectItem value="warning">{SEVERITY_LABELS.warning}</SelectItem>
      </SelectContent>
    </Select>
  );
}
